import { Tracking } from 'types';
import { baseApi } from './axios';
import { BaseAPIResponse } from 'types';

const baseUrl = `${process.env.REACT_APP_API_URL}/tracking`;

export const recordFETracking = async (args: Tracking): Promise<BaseAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/record-fe-tracking`, args);
	return response.data;
};
